import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { Col, Row, Table } from "reactstrap";
import { PlayerPlayGameRow } from "./PlayerPlayGameRow";
import { useGameQuery } from "../../hooks/useGameQuery";

import { AnimatePresence } from "framer-motion";

//load some dummy data
import roundsData from "../play/dummy-data";

import { client } from "../AppSyncClientProvider";

import GameQuery from "../../gql/queries/GameQuery";

import GameSubscription from "../../gql/subscriptions/GameSubscription";

import { PlayerInfo } from "../../lib/models/PlayerInfo";

import mapGameData from "../../lib/utils/mapGameData";

import { Button } from "reactstrap";

import { useSubscription } from "@apollo/react-hooks";

import MutationGameStatusPlayer_1 from "../../gql/mutations/MutationGameStatusPlayer_1";
import MutationGameStatusPlayer_2 from "../../gql/mutations/MutationGameStatusPlayer_2";
import MutationGameStatusPlayer_3 from "../../gql/mutations/MutationGameStatusPlayer_3";
import MutationGameStatusPlayer_4 from "../../gql/mutations/MutationGameStatusPlayer_4";
import { UserContext } from "../UserContext";

//game round / answers -- move to model?
interface answer {
  text: string;
  isCorrect: boolean;
}
interface round {
  answers: Array<answer>;
  questionText: string;
  questionTime: any;
  questionDifficulty: any;
}

interface RoundManagerProps {
  roundsData: Array<round>;
}

//
function useCounterState(total: number, onEnd?: Function) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  //Next Click From Round Componet
  function next(event: MouseEvent) {
    if (currentIndex + 1 > total) {
      setIsComplete(true);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  }

  const state: [number, Function, boolean] = [currentIndex, next, isComplete];
  return state;
}

const PlayGame = () => {
  const [players, setPlayers] = useState<PlayerInfo[]>([]);
  const [currentPlayer, setCurrentPlayer] = useState<PlayerInfo>({
    id: "",
    name: "",
    round: 0,
    score: 0
  });
  const [currentPlayerNumber, setCurrentPlayerNumber] = useState(0);

  const [currentRoundIdx, next, gameComplete] = useCounterState(
    roundsData.length - 1
  );

  const {user} = useContext(UserContext)
  const { id } = useParams();

  //const { data, loading, error }  = useSubscription(GameSubscription, {variables: {id: id}})

  //get the initial game state
  const fetchGame = () => {
    client
      .query({
        query: GameQuery,
        variables: { id: id },
        fetchPolicy: "no-cache"
      })
      .then(result => {
        const data: any = mapGameData(result.data.getGame);
        updateGameDataFromNetwokr(data);
      });
  };

  //init fetch via useeffect
  useEffect(() => {
    fetchGame();
  }, []);

  function updateGameDataFromNetwokr(data: any) {
    console.log("GAME UPDATE", data);
    setPlayers(data.players);
    const p = data.players as PlayerInfo[];
    const index = p.findIndex(p => p.id === user.id) || 0;
    if (index >= 0) {
      setCurrentPlayer(data.players[index]);
      setCurrentPlayerNumber(index);
    }
  }

  //game subscription
  // const observable = client.subscribe({ query: GameSubscription, variables: {id: id } });

  //  const realtimeResults = function realtimeResults(result : any) {
  //   //_this.updateGameStatus(result.data.onUpdateGame);
  //   console.log("SUBSCRIPTION UPDATE:" , result);
  //   const data : any = mapGameData(result.data.onUpdateGame)
  //   updateGameDataFromNetwokr(data);
  //   };

  //  //game subscription via use effect
  //  useEffect(() => {

  //         observable.subscribe({
  //           next: realtimeResults,
  //           complete: console.log,
  //           error: console.log,
  //       });

  //   },[]);

  //https://github.com/apollographql/react-apollo/issues/3577

  useEffect(() => {
    const observer = client.subscribe({
      query: GameSubscription,
      variables: { id: id }
    });

    const subscription = observer.subscribe(({ data }) => {
      console.log("SUBSCRIBE received", data);
      //setData(data);
    });

    return () => subscription.unsubscribe();
  }, [id]);

  //update the player score
  const handleUpdate = () => {
    console.log("CURRENT PLAYER NUMBER: " + currentPlayerNumber);

    //safty check
    if (currentPlayerNumber < 0 || currentPlayerNumber > 3) {
      return;
    }

    const mutationQuerys = [
      MutationGameStatusPlayer_1,
      MutationGameStatusPlayer_2,
      MutationGameStatusPlayer_3,
      MutationGameStatusPlayer_4
    ];

    const score = Math.floor(Math.random() * 1000 + 1) + currentPlayer.score;
    const round = currentPlayer.round + 1;

    client
      .mutate({
        mutation: mutationQuerys[currentPlayerNumber],
        variables: {
          id: id,
          playerId: currentPlayer.id,
          score: score,
          playerDisplayName: currentPlayer.name,
          round: round
        },
        fetchPolicy: "no-cache"
      })
      .then(result => {
        //dont do anything with data as we have subscription
      });
  };

  return (
    <>
      <Row>
        <Col>
          <h3>Game Play</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="small text-muted">{id}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Link to="/">Home</Link>
        </Col>
      </Row>
      <Row>
        <Col>Your Round: {currentPlayer.round}</Col>
      </Row>
      <Row>
        <Col>Your Score: {currentPlayer.score}</Col>
      </Row>
      <Row>
        <Col>Round Timer: N/A</Col>
      </Row>
      <Row>
        <Col>
          <Button color="link" onClick={() => handleUpdate()}>
            Update My Score
          </Button>
          <Table className="table-sm">
            <thead>
              <tr>
                <th>Slot</th>
                <th>Name</th>
                <th>Round</th>
                <th>Score</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {players?.map((p, i) => (
                <PlayerPlayGameRow
                  gameId={id}
                  key={`${i}-${p.id}`}
                  playerNumber={i + 1}
                  p={p}
                />
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      <>
        {!gameComplete && (
          <AnimatePresence exitBeforeEnter>
            {/* <Round
              key={currentRoundIdx}
              nextRound={next}
              round={roundsData[currentRoundIdx]}
              playerNumber={currentPlayerNumber}
              playerInfo={currentPlayer}
              gameId={id}
            /> */}
          </AnimatePresence>
        )}
        {gameComplete && "GAME OVER"}
      </>
    </>
  );
};
export default PlayGame;
